import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import tuliImg from "../image/tuli.jpg";
import "../App.css";
import Header from "../components/Header";


const API = "https://tulithevlogger.com/api/products/featured";
const IMAGE_BASE = "https://tulithevlogger.com/uploads";
const FEEDBACK_API = "https://tulithevlogger.com/api/feedback/featured";

const openWhatsApp = (service) => {
  const message = encodeURIComponent(
    `Namaste Tuli Ji 🙏
I would like to know more about: ${service}
Please guide me.
Thank you.`
  );

  window.open(
    `https://wa.me/916290140351?text=${message}`,
    "_blank"
  );
};

const Home = () => {
  const [products, setProducts] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(API)
      .then((res) => {
        setProducts(res.data.data || []);
      })
      .catch((err) => {
        console.error("HOME ERROR:", err);
      });
    axios
    .get(FEEDBACK_API)
    .then((res) => {
      setFeedbacks(res.data.data || []);
    })
    .catch((err) => {
      console.error("Feedback Error:", err);
    });
  }, []);

  return (
    <div className="home-page">
       <Header />
      {/* ================= BACKGROUND EFFECTS ================= */}

      <div className="star-layer">
        {Array.from({ length: 70 }).map((_, i) => (
          <span
            key={i}
            className="star"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`
            }}
          />
        ))}
      </div>

      <div className="chakra-aura"></div>

      {/* ================= HERO ================= */}

      <section className="hero-section">

        <div className="hero-content">

          <span className="hero-badge">
            ✨ 3.5L+ Subscribers & Growing
          </span>

          <h1 className="hero-title">
            🔮 Tuli The Vlogger
          </h1>

          <h2 className="hero-subtitle">
            Buy Certified Gemstones • Astrology Consultation • Horoscope Analysis • Spiritual Guidance • Online Puja Services
          </h2>
          
          <p className="hero-description">
            Discover authentic astrology insights, trusted gemstone
            recommendations, spiritual remedies, and guidance for a
            more balanced and successful life.
          </p>

          <div className="hero-buttons">

  <div className="button-row">

    <button
      className="btn-primary"
      onClick={() => navigate("/products")}
    >
      🛍 Shop Now
    </button>

    <button
      className="btn-gallery"
      onClick={() => navigate("/gallery")}
    >
      📸 View Gallery
    </button>

  </div>

  <div className="button-row">

    <button
      className="btn-secondary"
      onClick={() =>
        window.open(
          "https://www.youtube.com/@tulithevlogger",
          "_blank"
        )
      }
    >
      🎥 Watch On YouTube
    </button>

    <button
      className="btn-facebook"
      onClick={() =>
        window.open(
          "https://www.facebook.com/p/Tuli-The-Vlogger-100063635413327/",
          "_blank"
        )
      }
    >
      📘 Watch On Facebook
    </button>

  </div>

</div>

        </div>

        <div className="hero-image-wrapper">

          <div className="hero-image-ring"></div>

          <img
            src={tuliImg}
            alt="Tuli The Vlogger"
            className="hero-image"
          />

        </div>

      </section>

      {/* ================= TRUST STRIP ================= */}

      <section className="trust-strip">

        <div className="trust-item">
          ⭐ 3.5L+ Subscribers
        </div>

        <div className="trust-item">
          💎 Genuine Gemstones
        </div>

        <div className="trust-item">
          🧿 Astrology Guidance
        </div>

        <div className="trust-item">
          🚚 Fast Delivery
        </div>

      </section>

      {/* ================= SERVICES ================= */}

<section className="services-section">

  <h2 className="section-title">
    Astrology Consultation & Spiritual Services
  </h2>
  <p style={{
    textAlign: "center",
    color: "#666",
    marginTop: "-10px",
    marginBottom: "25px",
    fontSize: "16px"
  }}>
    📱 Consult with Tuli Ji on WhatsApp
  </p>
  <div className="services-grid">

    <div
      className="service-card"
      onClick={() => openWhatsApp("Astrology Consultation")}
      style={{ cursor: "pointer" }}
    >
      <div className="service-icon">🔮</div>
      <h3>Astrology Consultation</h3>
      <p>
        Personalized guidance based on Vedic astrology.
      </p>
    </div>

    <div
      className="service-card"
      onClick={() => openWhatsApp("Gemstone Recommendation")}
      style={{ cursor: "pointer" }}
    >
      <div className="service-icon">💎</div>
      <h3>Gemstone Recommendation</h3>
      <p>
        Discover gemstones aligned with your birth chart.
      </p>
    </div>

    <div
      className="service-card"
      onClick={() => openWhatsApp("Spiritual Remedies")}
      style={{ cursor: "pointer" }}
    >
      <div className="service-icon">🕉️</div>
      <h3>Spiritual Remedies</h3>
      <p>
        Practical remedies for prosperity and peace.
      </p>
    </div>

    <div
      className="service-card"
      onClick={() => openWhatsApp("Life Guidance")}
      style={{ cursor: "pointer" }}
    >
      <div className="service-icon">🌟</div>
      <h3>Life Guidance</h3>
      <p>
        Clarity for relationships, career and success.
      </p>
    </div>

  </div>

</section>

      {/* ================= PRODUCTS ================= */}

      <section className="products-section">

        <h2 className="section-title">
          🔥 Featured Products
        </h2>

        <div className="products-grid">

          {products.slice(0, 8).map((p) => {

            const image = p.Image || p.image;
            const id = p.Id || p.id;
            const name = p.Name || p.name;
            const price = p.Price || p.price;
            const categoryId = Number(p.CategoryId || p.categoryid);
            return (
              <div
                className="product-card"
                key={id}
              >

                {image ? (
                  <img
                    src={`${IMAGE_BASE}/${image}`}
                    alt={name}
                    className="product-image"
                  />
                ) : (
                  <div className="product-placeholder">
                    No Image
                  </div>
                )}

                <h3 className="product-name">
                  {name}
                </h3>

                <div className="product-price">
                  ₹{Number(price || 0).toLocaleString()}
                  {categoryId === 1 ? " / Crt" : ""}
                </div>

                <button
                  className="product-btn"
                  onClick={() => navigate("/products")}
                >
                  View Product
                </button>

              </div>
            );
          })}

        </div>

        <div className="center-button">
<center>
          <button
            className="btn-primary"
            onClick={() => navigate("/products")}
          >
            View All Products
          </button>
</center>
        </div>

      </section>

      {/* ================= ABOUT ================= */}

      <section className="about-section">

        <div className="about-image-area">
          <img
            src={tuliImg}
            alt="About Tuli"
            className="about-image"
          />
        </div>

        <div className="about-content">

          <h2>
            👩 About Tuli
          </h2>

          <p>
            Tuli is a trusted astrologer, content creator and
            spiritual guide helping thousands of people find
            clarity, confidence and positivity in their lives.
          </p>

          <p>
            Through astrology, gemstone guidance and spiritual
            knowledge, she has built a strong community of
            over 3.5 lakh subscribers.
          </p>

          <p>
            Her mission is to provide authentic spiritual
            insights that empower people to make better
            life decisions.
          </p>
<div className="about-buttons">

  <button
    className="btn-secondary"
    onClick={() =>
      window.open(
        "https://www.youtube.com/@tulithevlogger",
        "_blank"
      )
    }
  >
    🎥 YouTube Channel&nbsp;&nbsp;
  </button>

  <button
    className="btn-facebook"
    onClick={() =>
      window.open(
        "https://www.facebook.com/p/Tuli-The-Vlogger-100063635413327/",
        "_blank"
      )
    }
  >
    📘 Facebook Page&nbsp;&nbsp;
  </button>

</div>
        </div>

      </section>
      

      {/* ================= TESTIMONIALS ================= */}
<section className="feedback-section">

<h2 className="section-title">
❤️ Customer Experiences
</h2>
<div style={{ textAlign: "center", marginBottom: 30 }}>

  <button
    className="btn-primary"
    onClick={() => navigate("/feedback")}
  >
    ⭐ Share Your Experience
  </button>

</div>
<div className="feedback-grid">

{feedbacks.length===0 ? (

<div className="feedback-empty">
No featured feedback available.
</div>

) : (

feedbacks.map((item)=>{

const name=item.name || "Customer";

const letter=name.charAt(0).toUpperCase();

return(

<div
className="feedback-card"
key={item.feedbackid}
>

<div className="feedback-header">

<div className="feedback-avatar">
{letter}
</div>

<div className="feedback-user">

<h4>{name}</h4>

<div className="feedback-date">
{new Date(item.createdat).toLocaleDateString()}
</div>

</div>

</div>

<div className="feedback-stars">
{"⭐".repeat(item.rating)}
</div>

<div className="feedback-message">
"{item.message}"
</div>

</div>

);

})

)}

</div>

</section>
      {/* <section className="testimonial-section">

        <h2 className="section-title">
          ❤️ What People Say
        </h2>

        <div className="testimonial-grid">

          <div className="testimonial-card">
            <p>
              "Excellent guidance and genuine gemstone
              recommendations."
            </p>
            <h4>- Priya</h4>
          </div>

          <div className="testimonial-card">
            <p>
              "Her astrology insights helped me during
              a difficult phase."
            </p>
            <h4>- Amit</h4>
          </div>

          <div className="testimonial-card">
            <p>
              "One of the most trusted spiritual creators
              online."
            </p>
            <h4>- Suman</h4>
          </div>

        </div>

      </section> */}

      {/* ================= CTA ================= */}

      <section className="cta-section">

        <h2>
          Begin Your Spiritual Journey Today
        </h2>

        <p>
          Explore authentic products and trusted guidance.
        </p>

        <button
          className="btn-primary"
          onClick={() => navigate("/products")}
        >
          Explore Store
        </button>

      </section>

      {/* ================= FOOTER ================= */}

      <footer className="footer">

        <h3>Tuli The Vlogger</h3>

        <p>
          Astrology • Gemstones • Spiritual Guidance
        </p>

        <p>
          © 2026 tulithevlogger.com • All Rights Reserved
        </p>

      </footer>

    </div>
  );
};

export default Home;